import { render, staticRenderFns } from "./CreateScheduleExcel.vue?vue&type=template&id=b2d54cda&scoped=true"
import script from "./CreateScheduleExcel.vue?vue&type=script&lang=js"
export * from "./CreateScheduleExcel.vue?vue&type=script&lang=js"
import style0 from "./CreateScheduleExcel.vue?vue&type=style&index=0&id=b2d54cda&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d54cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2d54cda')) {
      api.createRecord('b2d54cda', component.options)
    } else {
      api.reload('b2d54cda', component.options)
    }
    module.hot.accept("./CreateScheduleExcel.vue?vue&type=template&id=b2d54cda&scoped=true", function () {
      api.rerender('b2d54cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/CreateScheduleExcel.vue"
export default component.exports